import styled from 'styled-components';
import { BaseButton } from '../../styles/styled';
import Colors, { hexToRgbA } from '../../styles/colors';

export const ProfileContainer = styled.div`
  background: #fff;
`;

export const InputLabel = styled.div`
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '1.6rem')};
  font-weight: 700;
  margin: 0px 0px 10px;
`;

export const InputText = styled.input`
  &[type='text'],
  &[type='email'],
  &[type='password'] {
    font-size: 1.6rem;
    border-radius: 4px;
    margin-bottom: 0px;
  }

  ${props => props.errored ? 'border: 1px solid #F44336 !important;' : ''}
`;

export const InputEmail = styled(InputText)`
  &:disabled {
    background-color: #fff9f6;
    border-color: #ffebe0;
  }
`;

export const FlexLine = styled.div`
  display: flex;
  align-items: center;
`;

export const EmailLine = styled(FlexLine)`
  height: 40px;
`;

export const FacebookLine = styled(FlexLine)`
  background-color: #3d5a96;
  border-radius: 4px;
  cursor: default;

  .fb-connected {
    background-image: url('/images/social/Facebook.svg');
    background-repeat: no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
  }
`;

export const StripeMiniLogo = styled.span`
  background-color: #6772e5;
  color: #fff;
  padding: 1px 8px;
  font-size: 1.35rem;
  border-radius: 4px;
  margin-left: 5px;

  &:before {
    content: 'Stripe';
  }
`;

export const LineBox = styled.div`
  padding: 20px;
  background: #fff9f6;
  border: 2px dashed #ffebe0;
  border-radius: 4px;
`;

export const CreditCardLine = styled(LineBox)`
  .card-actions {
    display: flex;
    justify-content: space-between;
  }
`;

export const ChangePasswordLine = styled(LineBox)`
  background: #f8f8f8;
  border: 2px dashed #efefef;
`;

export const DeleteAccountLine = styled(LineBox)`
  background: #fff9f9;
  border: 2px dashed #ffe9e9;
`;

export const EmailChangeBtn = styled(BaseButton)`
  width: 100%;
  font-size: 1.6rem;
  height: 40px;
`;

export const PasswordChangeBtn = styled(BaseButton)`
  background-color: #616161;
  border-color: #616161;
  width: 100%;
  font-size: 1.6rem;

  &:hover {
    border-color: ${hexToRgbA('#616161', 0.8)};
    background-color: ${hexToRgbA('#616161', 0.8)};
  }
`;

export const CreditCardBtn = styled.a`
  font-size: 1.6rem;
  color: ${Colors.mainOrange};

  &:hover {
    color: #f75d04;
  }
`;

export const ButtonText = styled.span`
  color: ${Colors.mainOrange};
  cursor: pointer;
`;

export const SaveButton = styled(BaseButton)`
  width: 100%;
  font-size: 1.6rem;
  height: 40px;
`;

export const CreatePlanButton = styled(SaveButton)`
  border-color: ${Colors.link};
  background-color: ${Colors.link};
  &:hover {
    border-color: ${hexToRgbA(Colors.link, 0.85)};
    background-color: ${hexToRgbA(Colors.link, 0.85)};
  }
`;

export const RemoveButton = styled(SaveButton)`
  background-color: #fff;
  border: 1px solid ${hexToRgbA('#F44336')};
  color: ${hexToRgbA('#F44336')};
  padding: 0;
  font-size: 1.3rem;

  &:hover {
    border-color: ${hexToRgbA('#F44336', 0.8)};
    background-color: ${hexToRgbA('#F44336', 0.8)};
    color: #fff;
  }
`;

export const ChangeButton = styled(BaseButton)`
  background-color: '#00BCD4';
  border-color: '#00BCD4';
`;

export const CancelButton = styled(BaseButton)``;
